import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import Vue from 'vue';
import Component from 'vue-class-component';
import { INJECT_SIMPLE_FLOW_EDITOR, INJECT_SIMPLE_FLOW_STEP_EDITOR, INJECT_SIMPLE_FLOW_STEP_LIST } from './consts';
import FlowAtomSelector from "./FlowAtomSelector";
import StepParamsEditor from "./StepParamsEditor";
import StepExprInputContextProvider from './StepExprInputContextProvider';
import { debounce } from "lodash-es";
import Markdown from "../../../lib/builtin/components/Markdown";
import MarkdownForTooltip from "../../../lib/comps/MarkdownForTooltip";
import { EventTitleFlex } from "../../../lib/comps/PropPanel/EventPanelNew/EventTitleFlex";
import { EventPanelIcons } from "../../../lib/comps/PropPanel/EventPanelNew/eventPanelIcons";
import { removeItems } from '@lyonbot/interactive-blocks';
import classNames from "../../../lib/utils/classNames";
import { readClipboard, uuidv4, writeClipboard } from "../../../lib/utils";
import ExprInput from "../../../lib/builtin/designerComponents/ExprInput";
import { CTRL_KEY_LABEL, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
const expandedSet = new WeakSet();
let SimpleFlowStepEditor = class SimpleFlowStepEditor extends Vue {
  constructor() {
    super(...arguments);
    this.isActive = false;
    this.ibHasFocus = false;
    this.isFirstSelected = false;
    this.showParams = false;
    /** 错误信息，会在 validate() 里更新 */
    this.errors = null;
    this.backfillFocused = false;
    this.tempCondition = '';
    this.conditionEditFocused = false;
    // renderToolList() {
    //   return (
    //     <div class="ucd-sfeStep-actions-middle  ucd-sfeStep-title-toolIcons">
    //       <a-tooltip title={this.step.disabled ? '启用步骤' : '禁用步骤'}>
    //         <button
    //           class="ucd-sfeStep-button"
    //           onClick={(ev) => {
    //             this.$set(this.step, 'disabled', !this.step.disabled);
    //             ev.stopPropagation();
    //           }}
    //         >
    //           <img src={this.step.disabled ? EventPanelIcons.disdisableIcon : EventPanelIcons.disableIcon} />
    //         </button>
    //       </a-tooltip>
    //       <a-tooltip title="修改步骤描述">
    //         <button
    //           class="ucd-sfeStep-button"
    //           onClick={(ev: Event) => {
    //             ev.stopPropagation();
    //             this.toggleTitleRename();
    //           }}
    //         >
    //           <i class="fa fa-tag" aria-hidden="true"></i>
    //           {/* <img src={EventPanelIcons.editIcon} />*/}
    //         </button>
    //       </a-tooltip>
    //       <button
    //         class="ucd-sfeStep-button"
    //         onClick={(ev) => {
    //           this.stepList.copyStep(this.index);
    //           ev.stopPropagation();
    //         }}
    //       >
    //         <img src={EventPanelIcons.copyIcon} />
    //       </button>
    //       <button
    //         class="ucd-sfeStep-button"
    //         onClick={() => {
    //           this.stepList.removeStep(this.index);
    //         }}
    //       >
    //         <img src={EventPanelIcons.deleteIcon} />
    //       </button>
    //     </div>
    //   );
    // }
    this.titleRename = false;
    this.renameTemp = '';
  }
  get step() {
    return this.stepList.steps[this.index];
  }
  get atom() {
    return this.flowEditor.atoms[this.step.type];
  }
  get hasParams() {
    var _this$atom$paramsSche, _this$atom;
    return ((_this$atom$paramsSche = (_this$atom = this.atom) === null || _this$atom === void 0 || (_this$atom = _this$atom.paramsSchema) === null || _this$atom === void 0 || (_this$atom = _this$atom.fields) === null || _this$atom === void 0 ? void 0 : _this$atom.length) !== null && _this$atom$paramsSche !== void 0 ? _this$atom$paramsSche : 0) > 0;
  }
  get isDragging() {
    const d = this.stepList.isDragging;
    return !!d && d.includes(this.index);
  }
  handlePointerUp(ev) {
    if (this.mouseDownBtn !== 0) {
      ev.stopPropagation();
      return;
    }
    this.ibBlock.handlePointerUp();
    if (document.activeElement === ev.currentTarget) this.ibBlock.ctx.focus();
  }
  created() {
    this.ibBlock = this.stepList.ibSlot.createBlock({
      index: () => this.index,
      data: () => this.step,
      ref: this,
      onStatusChange: block => {
        this.isActive = block.isActive;
        this.ibHasFocus = block.hasFocus;
        this.isFirstSelected = block.activeNumber === 1 && block.hasFocus;
      }
    });
    this.validate = debounce(() => {
      var _this$atom2;
      this.errors = (_this$atom2 = this.atom) === null || _this$atom2 === void 0 ? void 0 : _this$atom2.validateParams(this.flowEditor.flowCtxBase, this.step.params);
    }, 500);
    this.$watch(() => this.step.params, this.validate, {
      deep: true,
      immediate: true
    });
    // 就算组件销毁了也要保持展开状态
    this.$watch(() => this.step, () => {
      this.showParams = expandedSet.has(this.step);
    }, {
      immediate: true
    });
    this.$watch(() => this.showParams, visible => {
      expandedSet[visible ? 'add' : 'delete'](this.step);
    });
    // 条件编辑相关
    this.$watch(() => this.step.condition || '', x => {
      this.tempCondition = x;
    }, {
      immediate: true
    });
  }
  beforeDestroy() {
    this.validate.cancel();
    this.ibBlock.dispose();
  }
  get displayName() {
    const {
      step,
      atom
    } = this;
    const atomName = (atom === null || atom === void 0 ? void 0 : atom.name) || (atom === null || atom === void 0 ? void 0 : atom.id) || '未配置步骤';
    const ppName = step.note || (atom === null || atom === void 0 ? void 0 : atom.getDisplayName(step));
    if (ppName) return `${ppName} (${atomName})`;
    return atomName;
  }
  toggleParams(ev) {
    if (ev !== null && ev !== void 0 && ev.shiftKey || ev !== null && ev !== void 0 && ev.metaKey || ev !== null && ev !== void 0 && ev.ctrlKey) return;
    this.showParams = !this.showParams;
    this.ibBlock.ctx.focus();
  }
  get isConditionedBegin() {
    var _this$stepList$steps;
    const cond = this.step.condition;
    return !!cond && ((_this$stepList$steps = this.stepList.steps[this.index - 1]) === null || _this$stepList$steps === void 0 ? void 0 : _this$stepList$steps.condition) !== cond;
  }
  get isConditionedEnd() {
    var _this$stepList$steps2;
    const cond = this.step.condition;
    return !!cond && ((_this$stepList$steps2 = this.stepList.steps[this.index + 1]) === null || _this$stepList$steps2 === void 0 ? void 0 : _this$stepList$steps2.condition) !== cond;
  }
  handleConditionBlur() {
    this.conditionEditFocused = false;
    const condition = this.tempCondition;
    if (condition === this.step.condition) return;
    const indexes = this.getConditionGroupIndexes();
    this.stepList.steps.forEach((step, index) => {
      // eslint-disable-next-line no-param-reassign
      if (indexes.includes(index)) step.condition = condition;
    });
    this.flowEditor.flushChanges();
  }
  handleConditionFocus() {
    this.conditionEditFocused = true;
  }
  handleMouseDown(ev) {
    this.mouseDownBtn = ev.button;
  }
  handleContextMenuEvent(ev) {
    var _ev$preventDefault, _stepVms$find;
    const {
      designer
    } = this;
    if (!designer) return;
    if (!this.ibBlock.isActive) {
      this.ibBlock.select('none');
    }
    const ibCtx = this.ibBlock.ctx;
    const selectedBlocks = Array.from(ibCtx.activeBlocks);
    const stepVms = selectedBlocks.map(x => x.ref);
    if (!stepVms.length) return;
    const firstStep = selectedBlocks[0].data;
    const wasDisabled = !!firstStep.disabled;
    const indexes = stepVms.map(X => X.index);
    const indexesDesc = indexes.slice().sort((a, b) => b - a);
    ibCtx.focus();
    (_ev$preventDefault = ev.preventDefault) === null || _ev$preventDefault === void 0 || _ev$preventDefault.call(ev);
    let newCondition = ((_stepVms$find = stepVms.find(x => x.step.condition)) === null || _stepVms$find === void 0 ? void 0 : _stepVms$find.step.condition) || '';
    if (newCondition) {
      if (stepVms.every(s => s.step.condition === newCondition)) {
        // all selected has same cond. clear them
        newCondition = '';
      }
    } else {
      var _this$stepList$steps3, _this$stepList$steps4;
      newCondition = ((_this$stepList$steps3 = this.stepList.steps[indexesDesc[indexesDesc.length - 1] - 1]) === null || _this$stepList$steps3 === void 0 ? void 0 : _this$stepList$steps3.condition) || ((_this$stepList$steps4 = this.stepList.steps[indexesDesc[0] + 1]) === null || _this$stepList$steps4 === void 0 ? void 0 : _this$stepList$steps4.condition) || '1 + 1 == 2';
    }
    const deleteSteps = () => {
      this.stepList.removeStep(indexes);
      selectedBlocks.splice(0);
    };
    const copyToClipboard = () => {
      ibCtx.clearSelection();
      selectedBlocks.forEach(b => b.select('ctrl'));
      const txt = ibCtx.options.serializeForClipboard(ibCtx.dumpSelectedData());
      writeClipboard(txt);
    };
    const copyLessCodeToClipboard = () => {
      var _this$designer;
      ibCtx.clearSelection();
      selectedBlocks.forEach(b => b.select('ctrl'));
      const txt = ibCtx.options.serializeForClipboard(ibCtx.dumpSelectedData());
      const {
        blocksData
      } = JSON.parse(txt);
      // 格式化JSON内容，使数组的每一项呈一行显示并缩进
      const stringifyData = `[
${blocksData.map(item => `  ${JSON.stringify(item)}`).join(',\n')}
]`;
      const lessCodeData = `const { state } = await this.executeSimpleFlow(${stringifyData})`;
      writeClipboard(lessCodeData);
      (_this$designer = this.designer) === null || _this$designer === void 0 || _this$designer.uc.$message('已复制，可以在 LessCode 中粘贴使用');
    };
    designer.openContextMenu(ev, [{
      title: '步骤编辑',
      items: [{
        title: '启用/禁用步骤',
        checked: !wasDisabled,
        execute: () => {
          var _this$designer2;
          stepVms.forEach(v => this.$set(v.step, 'disabled', !wasDisabled));
          this.flowEditor.flushChanges();
          (_this$designer2 = this.designer) === null || _this$designer2 === void 0 || _this$designer2.uc.$message.info('可点击步骤前面的序号，快速启用/禁用步骤');
        }
      }, {
        title: '删除',
        icon: 'fa fa-trash',
        execute: deleteSteps
      }, {
        title: '修改描述',
        icon: 'fa fa-tag',
        execute: stepVms.length === 1 ? () => {
          this.$nextTick(() => stepVms[0].toggleTitleRename());
        } : void 0
      }, {
        title: '满足..条件才执行',
        icon: 'fa fa-question',
        checked: !newCondition,
        execute: () => {
          var _this$designer3;
          stepVms.forEach(v => this.$set(v.step, 'condition', newCondition));
          this.flowEditor.flushChanges();
          (_this$designer3 = this.designer) === null || _this$designer3 === void 0 || _this$designer3.uc.$message.info('按Shift+点击步骤前面的序号，也能配置');
        }
      }, {
        title: '---'
      }, {
        title: '剪切',
        execute: () => {
          copyToClipboard();
          deleteSteps();
        }
      }, {
        title: '复制',
        execute: () => {
          copyToClipboard();
        }
      }, {
        title: '粘贴',
        execute: async () => {
          try {
            const txt = await readClipboard();
            const data = ibCtx.options.unserializeForClipboard(txt);
            this.ibBlock.select('none');
            ibCtx.pasteWithData(data);
            selectedBlocks.splice(0);
            ibCtx.focus();
          } catch (er) {
            var _this$designer4;
            const msg = `无剪贴板权限。请尝试 ${CTRL_KEY_LABEL}-V`;
            (((_this$designer4 = this.designer) === null || _this$designer4 === void 0 ? void 0 : _this$designer4.uc.$message.error) || window.alert)(msg);
          }
        }
      }, {
        title: '导出LessCode调用',
        execute: async () => {
          copyLessCodeToClipboard();
        }
      }]
    }], () => {
      if (!selectedBlocks.length) return;
      ibCtx.clearSelection();
      selectedBlocks.forEach(b => b.select('ctrl'));
      ibCtx.focus();
    });
  }
  get returnValue() {
    var _this$atom3, _this$atom3$returnVal, _this$designer5, _this$designer6;
    return (_this$atom3 = this.atom) === null || _this$atom3 === void 0 || (_this$atom3$returnVal = _this$atom3.returnValue) === null || _this$atom3$returnVal === void 0 ? void 0 : _this$atom3$returnVal.call(_this$atom3, this.step.params, {
      uc: (_this$designer5 = this.designer) === null || _this$designer5 === void 0 ? void 0 : _this$designer5.uc,
      designer: this.designer,
      renderer: (_this$designer6 = this.designer) === null || _this$designer6 === void 0 ? void 0 : _this$designer6.renderer
    });
  }
  render() {
    const h = arguments[0];
    const {
      errors,
      index,
      step,
      atom,
      hasParams,
      showParams
    } = this;
    const showBackfill = !!(this.backfillFocused || this.returnValue);
    return h(EventTitleFlex, {
      "class": mergeClassName('ucd-sfeStep', !!(errors !== null && errors !== void 0 && errors.length) && 'hasError', showParams && 'isExpanded', step.disabled && 'isDisabled', this.isActive && 'isActive', this.isDragging && 'isDragging', this.ibHasFocus && 'ibHasFocus', !!step.condition && 'isConditioned', this.isConditionedBegin && 'isConditionedBegin', this.isConditionedEnd && 'isConditionedEnd'),
      "on": {
        "mousedown": this.handleMouseDown,
        "contextmenu": this.handleContextMenuEvent
      }
    }, [h("a-tooltip", {
      "slot": "toggle",
      "attrs": {
        "placement": "left",
        "title": step.disabled ? '点击启用步骤' : h("pre", {
          "style": "margin-bottom: 0"
        }, ['- 点击可禁用步骤\n- 拖动可改变顺序\n- Shift+点击可配置执行条件']),
        "overlayStyle": {
          'pointer-events': 'none'
        }
      }
    }, [h("div", {
      "class": "ucd-sfeStep-toggle",
      "on": {
        "pointerup": ev => {
          const {
            index,
            step
          } = this;
          if (ev.shiftKey) {
            var _steps, _steps2;
            const {
              steps
            } = this.stepList;
            const condition = step.condition ? '' : ((_steps = steps[index - 1]) === null || _steps === void 0 ? void 0 : _steps.condition) || ((_steps2 = steps[index + 1]) === null || _steps2 === void 0 ? void 0 : _steps2.condition) || '1 + 1 == 2';
            this.$set(step, 'condition', condition);
            ev.stopPropagation();
            if (!this.ibBlock.isActive) this.ibBlock.select();
            this.ibBlock.ctx.focus();
          } else {
            this.$set(step, 'disabled', !this.step.disabled);
            this.handlePointerUp(ev);
          }
          this.flowEditor.flushChanges();
        }
      }
    }, [h("div", {
      "class":
      // eslint-disable-next-line no-nested-ternary
      `ucd-sfeToggle ${step.disabled ? 'isGrey' : step.condition ? 'isYellow' : 'isGreen'}`
    }, [index + 1])])]), this.titleRename ? h("div", {
      "slot": "title",
      "class": "ucd-sfeStep-title"
    }, [this.renderRename()]) : null, !this.titleRename ? h("div", {
      "slot": "title",
      "attrs": {
        "tabIndex": "-1"
      },
      "class": "ucd-sfeStep-title",
      "on": {
        "click": this.toggleParams,
        "pointerup": this.handlePointerUp
      }
    }, [h("div", {
      "class": "ucd-sfeStep-title-name"
    }, [this.displayName]), this.renderSubTitle(), h("div", {
      "class": "ucd-sfeStep-title-handle"
    }), h("div", {
      "class": "ucd-sfeStep-actions"
    }, [h("button", {
      "class": "ucd-sfeStep-button ucd-sfeStep-arrowButton"
    }, [h("img", {
      "class": {
        Rotate: showParams
      },
      "attrs": {
        "src": EventPanelIcons.arrowDown
      }
    })]), this.renderToolListDrawer()])]) : null, hasParams && showParams && h("div", {
      "class": "ucd-sfeStep-params"
    }, [h("step-expr-input-context-provider", {
      "attrs": {
        "index": index
      }
    }, [h("step-params-editor", _mergeJSXProps([{
      "attrs": {
        "atom": atom,
        "step": step
      }
    }, {
      "on": {
        'update:params': val => {
          this.$set(step, 'params', val);
        },
        'update:backfill': this.setBackFill
      }
    }]))]), this.renderBackfill(showBackfill)]), !!step.condition && h("div", {
      "key": "conditionRect",
      "class": classNames('ucd-sfeStep-conditionBorder', !this.isConditionedBegin && 'isNotBegin', !this.isConditionedEnd && 'isNotEnd')
    }), this.conditionGroupHeader, this.firstSelectSidebar]);
  }
  get firstSelectSidebar() {
    if (!this.isFirstSelected) return null;
  }
  convertConditionGroupToIfAtom() {
    const indexes = this.getConditionGroupIndexes();
    if (!indexes.length) return;
    const condition = this.step.condition;
    const index = Math.min(...indexes);
    const newStepList = this.stepList.steps.slice(0);
    const extractedSteps = removeItems(newStepList, indexes).map(x => ({
      ...x,
      condition: ''
    }));
    newStepList.splice(index, 0, {
      type: 'uicore:if',
      params: {
        branches: [{
          expanded: true,
          disabled: false,
          condition,
          steps: extractedSteps
        }],
        endOnFirstMatch: true,
        flowStatePass: true
      },
      _key: uuidv4()
    });
    this.stepList.steps.splice(0, this.stepList.steps.length, ...newStepList);
    this.flowEditor.flushChanges();
    this.$nextTick(async () => {
      await this.stepList.ibSetActiveBlocks([index]);
      this.flowEditor.ibContext.activeBlocks.forEach(b => {
        const r = b.ref;
        r && (r.showParams = true);
      });
    });
  }
  getConditionGroupIndexes() {
    const indexes = [];
    const {
      steps
    } = this.stepList;
    const {
      condition
    } = this.step;
    for (let i = this.index; i < steps.length && steps[i].condition === condition; i++) indexes.push(i);
    return indexes;
  }
  get conditionGroupHeader() {
    const h = this.$createElement;
    if (!this.isConditionedBegin) return null;
    return h("div", _mergeJSXProps2([{
      "key": "conditionBegin",
      "class": "ucd-sfeStep-conditionBegin"
    }, {
      "on": {
        '!mousedown': this.handleConditionGroupHeaderClick
      }
    }]), [h("div", {
      "class": "ucd-sfeStep-conditionIcon"
    }, ["if"]), h(ExprInput, {
      "key": "conditionEdit",
      "attrs": {
        "hideIcon": true
      },
      "on": {
        "focus": this.handleConditionFocus,
        "blur": this.handleConditionBlur
      },
      "class": classNames('ucd-sfeStep-conditionEdit', this.conditionEditFocused && 'hasFocus'),
      "model": {
        value: this.tempCondition,
        callback: $$v => {
          this.tempCondition = $$v;
        }
      }
    }), h("div", [h("a-tooltip", {
      "attrs": {
        "title": "转换为“条件分支”"
      }
    }, [h("i", {
      "class": "fa fa-share",
      "on": {
        "click": this.convertConditionGroupToIfAtom
      },
      "style": "cursor: pointer"
    })])])]);
  }
  handleConditionGroupHeaderClick(e) {
    this.stepList.ibSetActiveBlocks(this.getConditionGroupIndexes(), e.target.matches('.ucd-sfeStep-conditionEdit, .ucd-sfeStep-conditionEdit *'));
  }
  setBackFill(val) {
    const {
      step
    } = this;
    if (!val && !step.backfill) return;
    if (!val) this.$delete(step, 'backfill');else this.$set(step, 'backfill', val);
  }
  // drawerVisible = false;
  renderToolListDrawer() {
    const h = this.$createElement;
    return h("div", {
      "on": {
        "click": ev => {
          ev.stopPropagation();
        },
        "mousedown": ev => this.handleContextMenuEvent(ev)
      },
      "style": "width:16px;cursor:pointer"
    }, [h("i", {
      "attrs": {
        "aria-hidden": "true"
      },
      "class": "fa fa-ellipsis-v"
    })]);
    // return (
    //   <Curtain
    //     trigger={['click', 'hoverOut']}
    //     visible={this.drawerVisible}
    //     on={{ 'update:visible': e => this.drawerVisible = e }}
    //     class='ucd-sfeStep-toolListDrawer'
    //     placement={'left'}
    //     contentUnVisibleClass='ucd-sfeStep-actions-content'
    //   >
    //     <div slot="trigger" class="ucd-sfeStep-toolListDrawer-trigger">
    //       <i class="fa fa-ellipsis-v" aria-hidden="true" />
    //     </div>
    //     {this.renderToolList()}
    //   </Curtain>
    // );
  }
  toggleTitleRename() {
    this.renameTemp = this.step.note || '';
    this.titleRename = !this.titleRename;
    this.$nextTick(() => {
      if (this.titleRename) {
        var _this$$el$querySelect;
        (_this$$el$querySelect = this.$el.querySelector('input')) === null || _this$$el$querySelect === void 0 || _this$$el$querySelect.focus();
      } else {
        this.flowEditor.flushChanges();
        this.ibBlock.ctx.focus();
      }
    });
  }
  get subTitle() {
    var _this$atom4;
    return (_this$atom4 = this.atom) === null || _this$atom4 === void 0 ? void 0 : _this$atom4.getEventPanelSubTitle(this.step);
  }
  handleKeydown(ev) {
    if (ev.key === 'Enter') {
      this.$set(this.step, 'note', this.renameTemp);
      this.toggleTitleRename();
      return;
    }
    if (ev.key === 'Escape') {
      this.toggleTitleRename();
      return;
    }
  }
  renderSubTitle() {
    const h = this.$createElement;
    return this.subTitle && h("div", {
      "class": "ucd-sfeSubTitle"
    }, [this.subTitle]);
  }
  renderRename() {
    const h = this.$createElement;
    if (!this.titleRename) return undefined;
    return h("div", {
      "class": "ucd-sfeStep-title-renameBox",
      "on": {
        "click": ev => {
          ev.stopPropagation();
        }
      }
    }, [h("a-input", {
      "attrs": {
        "placeholder": "备注信息"
      },
      "on": {
        "keydown": this.handleKeydown
      },
      "model": {
        value: this.renameTemp,
        callback: $$v => {
          this.renameTemp = $$v;
        }
      }
    }), h("a", {
      "attrs": {
        "tabindex": "0"
      },
      "on": {
        "click": ev => {
          ev.stopPropagation();
          ev.preventDefault();
          this.$set(this.step, 'note', this.renameTemp);
          this.toggleTitleRename();
        }
      }
    }, ["\u786E\u5B9A"])]);
  }
  renderBackfillToolTip() {
    const h = this.$createElement;
    const {
      step,
      returnValue
    } = this;
    let desc = '';
    if (returnValue) {
      if (returnValue.title) desc += ` ${returnValue.title}`;
      if (returnValue.type && returnValue.type !== 'any') desc += ` (${returnValue.type})`;
      if (returnValue.description) desc += ` ${returnValue.description}`;
      desc = desc.trim();
    }
    if (desc) desc = `此步骤会输出 ${desc}`;
    return h("a-tooltip", {
      "attrs": {
        "placement": "top"
      }
    }, [h("markdown-for-tooltip", {
      "slot": "title",
      "attrs": {
        "source": `${desc}\n\n${step.backfill ? `后续步骤可通过 \`{{ flowState.${step.backfill} }}\` 引用` : '可配置一个变量名，以便传递给后续步骤'}`.trim()
      }
    }), h("div", {
      "class": "ucd-sfeBackfill-circle"
    }, [h("a-icon", {
      "attrs": {
        "type": "question-circle"
      }
    })])]);
  }
  renderBackfill(showBackfill) {
    const h = this.$createElement;
    if (!showBackfill) return null;
    const {
      step
    } = this;
    return h("div", {
      "class": "ucd-sfeBackfill",
      "style": "margin-top:12px;"
    }, [h("div", {
      "style": "white-space:nowrap;margin-right:4px;"
    }, ["\u8F93\u51FA :"]), h("input", {
      "attrs": {
        "type": "text",
        "placeholder": "输出变量名",
        "maxLength": 16
      },
      "class": "ucd-sfeBackfill-input",
      "domProps": {
        "value": step.backfill || ''
      },
      "on": {
        "input": e => {
          const val = e.target.value;
          if (/^[a-zA-Z_$][\w$]*$/.test(val) || !val) this.setBackFill(val);else e.target.value = step.backfill || '';
        },
        "focus": () => void (this.backfillFocused = true),
        "blur": () => void (this.backfillFocused = false)
      }
    }), this.renderBackfillToolTip()]);
  }
};
SimpleFlowStepEditor = __decorate([Component({
  name: 'SimpleFlowStepEditor',
  components: {
    FlowAtomSelector,
    StepExprInputContextProvider,
    StepParamsEditor,
    Markdown,
    MarkdownForTooltip
  },
  model: {
    prop: 'step',
    event: 'change'
  },
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  inject: {
    flowEditor: {
      from: INJECT_SIMPLE_FLOW_EDITOR
    },
    stepList: {
      from: INJECT_SIMPLE_FLOW_STEP_LIST
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  },
  provide() {
    return {
      [INJECT_SIMPLE_FLOW_STEP_EDITOR]: this
    };
  }
})], SimpleFlowStepEditor);
export default SimpleFlowStepEditor;
//# sourceMappingURL=SimpleFlowStepEditor.js.map
